import React, { useState } from 'react';
import styles from './styles/FreeResponseBody.module.css';
import { stripHtml } from '../../../utils/utils';
import { useScenario } from '../../../context/ScenarioContext';
import HintModal from './HintModal';

const FreeResponseBody = ({ situation, setCurrentSituationId, isScenarioLogged, preview, assignmentId, universalLock, userLock }) => {
    const [userResponse, setUserResponse] = useState('');
    const [showHintModal, setShowHintModal] = useState(false);
    const [hintText, setHintText] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { submitDecision } = useScenario();

    const handleInputChange = (event) => {
        setUserResponse(event.target.value);
    };

    const handleSubmit = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        const strippedUserResponse = stripHtml(userResponse).trim().toLowerCase();

        const matchingChoice = situation.choices.find(choice =>
            stripHtml(choice.text).trim().toLowerCase() === strippedUserResponse
        );

        if (matchingChoice) {
            if (matchingChoice.hasHint) {
                // Correct match, but a hint is shown — record the choice and stay
                // on this situation (no nextSituationId, so the log doesn't advance).
                if (isScenarioLogged && !preview) {
                    await submitDecision({
                        situationId: situation._id,
                        choiceId: matchingChoice._id,
                        correctness: matchingChoice.correctness,
                        type: 'choice',
                        userInput: null,
                        assignmentId,
                        fromToC: false
                    });
                }
                setHintText(matchingChoice.hint);
                setShowHintModal(true);
                setIsSubmitting(false);
            } else {
                // Correct match — record the choice and advance to the next situation.
                // The live teacher view picks the move up from ViewScenario's
                // progress effect; navigation never waits on the socket.
                if (isScenarioLogged && !preview) {
                    await submitDecision({
                        situationId: situation._id,
                        choiceId: matchingChoice._id,
                        correctness: matchingChoice.correctness,
                        type: 'choice',
                        userInput: null,
                        nextSituationId: matchingChoice.nextSituation?._id,
                        assignmentId,
                        fromToC: false
                    });
                }

                setCurrentSituationId(matchingChoice.nextSituation._id);
                setUserResponse('');
                setIsSubmitting(false);
            }
        } else {
            // No match — record the incorrect free-response input and stay put.
            if (isScenarioLogged && !preview) {
                await submitDecision({
                    situationId: situation._id,
                    choiceId: null,
                    correctness: 'incorrect',
                    type: 'input',
                    userInput: strippedUserResponse,
                    assignmentId,
                    fromToC: false
                });
            }
            setHintText('Try Again!');
            setShowHintModal(true);
            setIsSubmitting(false);
        }
    };

    const closeModal = () => {
        setShowHintModal(false);
        setHintText('');
    };

    return (
        <div className={styles.container}>
            <textarea
                className={styles.textarea}
                value={userResponse}
                onChange={handleInputChange}
                placeholder="Enter your response here..."
                disabled={isSubmitting}
            />
            <button className={`${styles.submitButton} ${(universalLock || userLock) ? styles.disabledChoice : ''}`} onClick={handleSubmit} disabled={isSubmitting || universalLock || userLock}>
                {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>

            {showHintModal && (
                <HintModal hintText={hintText} closeModal={closeModal} />
            )}
        </div>
    );
};

export default FreeResponseBody;
